import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'next/image';
import { useCallback } from 'react';
import { useSortBy, UseSortByProps } from 'react-instantsearch';
import sortIcon from '@/public/images/icons/sort.svg';
import { Button } from 'react-bootstrap';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
const CustomSortBy = (props: UseSortByProps) => {
  const { translate } = useTypedTranslation<CommonEnum>('common');
  const { initialIndex, currentRefinement, options, refine } = useSortBy(props);

  const getCurrentRefinementName = useCallback(() => {
    let index = options.find(option => option.value === currentRefinement);
    if (!index) {
      index = options.find(option => option.value === initialIndex);
    }
    return index?.label || translate(CommonEnum.sort_by);
  }, [currentRefinement, initialIndex, options, translate]);

  return (
    <Dropdown>
      <Dropdown.Toggle
        id="dropdown-basic"
        className="!tw-flex !tw-items-center !tw-justify-center !tw-gap-2 !tw-border-gray-300 !tw-bg-transparent !tw-text-black hover:!tw-bg-gray-200 hover:!tw-text-gray-900 active:!tw-bg-gray-300 active:!tw-text-black"
      >
        <Image src={sortIcon} alt="sort" width={16} height={16} />
        <span className="tw-font-semibold">{getCurrentRefinementName()}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu align={'end'}>
        {options.map((sort, index) => (
          <Dropdown.Item
            active={sort.value === currentRefinement}
            as={Button}
            onClick={() => refine(sort.value)}
            key={index}
          >
            {sort.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomSortBy;
